// Function to set a cookie
function setCookie(cname, cvalue, minutes) {
  var d = new Date();
  d.setTime(d.getTime() + minutes * 60 * 1000); // Set expiration time to X minutes
  var expires = "expires=" + d.toUTCString();

  // Set the cookie with path and optional SameSite attribute
  document.cookie =
    cname +
    "=" +
    encodeURIComponent(cvalue) +
    ";" +
    expires +
    ";path=/;SameSite=Lax";
}

// Function to get a cookie
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// Check if the referrer is from Google and create a cookie
function checkGoogleReferral() {
  var referrer = document.referrer;
  var googleDomains = [
    "google.com",
    "google.co",
    "google.ae",
    "google.ca",
    "google.uk",
  ];

  // Check if the referrer contains "google" and isn't empty
  if (referrer && googleDomains.some((domain) => referrer.includes(domain))) {
    setCookie("organic", "true", 5);
    console.log("Organic referral cookie created.");
  }
}

// Function to check if the "organic" cookie exists
function checkIfOrganicCookieExists() {
  var organicCookie = getCookie("organic");
  return organicCookie;
}

// Run the check for Google referral and create the cookie if necessary
checkGoogleReferral();
